import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_GLOBAL_DATA);

const state = {
    data: {},
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    isGlobalDataFetched: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        state.isGlobalDataFetched = true;
        //console.log('fetched data', state.data)
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
}

const updateToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
    async fetchAll({ commit }) {
        //console.log("[state/globalapi/fetchAll] Calling API...");
        try {
            updateToken();
            commit("setFetching", true);
            let res = await axios_instance.get();
            //console.log("[state/dashboard/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", res.data.payload);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}